import React from 'react';
import PropTypes from 'prop-types';
import pickerControl from '../hoc/pickerControl';
import TextPicker from './TextPicker';
import PlayerPicker from './PlayerPicker';
import TeamPicker from './TeamPicker';

const TextPickerControl = pickerControl(TextPicker);
const PlayerPickerControl = pickerControl(PlayerPicker);
const TeamPickerControl = pickerControl(TeamPicker);

const PickersControls = () => {
    return (
        <div>
            <TextPickerControl />
            <PlayerPickerControl />
            <TeamPickerControl />
        </div>
    );
};

PickersControls.propTypes = {
    type: PropTypes.string,
};

export default PickersControls;



/** WEBPACK FOOTER **
 ** ../src/dash/front/editor/pickers/components/PickersControls.js
 **/